<template>
    <div class="user-profile">
        <b-modal id="change-pass-modal" title="Change Password" @ok="changePassword">
            <ap-form ref="changePassword" :fields="passFields" />
            <div class="error" v-if="passError">{{passError}}</div>
        </b-modal>
        <h2>
            <span>
                User data
            </span>
        </h2>
        <div class="user-form">
            <div class="avatar-item">
                <edit-user-avatar />
                <div class="user-info-wrap">
                    <p class="name">{{currentUser.first_name + ' ' + currentUser.second_name}}</p>
                    <span>{{ positions.join(', ') }}</span>
                </div>
            </div>
            <div class="edit-form">
                <ap-form
                    :fields="fields"
                    :values="currentUser"
                    :buttons="buttons"
                    @change="save"
                    @customBtnClick="openPassModal"
                />
            </div>
        </div>
        <h2>
            <span>
                Notifications
            </span>
        </h2>

        <div class="notification-checkboxes">
            <ap-form
                v-if="Object.keys(userNotifications).length"
                :fields="notifyFields"
                :values="userNotifications"
                ref="checkboxes"
                @checkboxCheck="updateSettings"
            />
        </div>
    </div>
</template>

<script>
import ApForm from '@/components/ApForm';
import EditUserAvatar from '@/components/EditUserAvatar';
import {COUNTRIES, TIME_ZONES} from '@/utils/const';
import auth from '@/auth'
    export default {
        components: {
            EditUserAvatar,
            ApForm
        },
        data() {
            return {
                userActions: null,
                passError: ''
            }
        },
        created() {
            this.$store.dispatch('notifications/notificationSettingsList')
            this.$store.dispatch('wsusers/loadAllUserWorkspaces', this.currentUser.id)
        },
        mounted() {
            this.$dispatch('auth/loadUsersActions').then(res => {
                res.forEach(action => {
                    if (action === "telegram-id") {
                        this.userActions = action
                    }
                })
            })
        },
        computed: {
            positions() {
                let positions = []
                let workspaces = this.$store.getters['wsusers/getByUserId'](this.currentUser.id, 'all')
                if (!workspaces.length) return positions
                workspaces.forEach(ws => {
                    let p = this.$store.getters['wspositions/getByID'](ws.workspace_position_id);
                    if (p) {
                        positions.push(p.position_title)
                    }
                })
                return positions
            },
            passFields() {
                return {
                    old_password: {
                        title: 'Old password',
                        type: 'password',
                        placeholder: 'Type your old password',
                        validation: ['required', 'password']
                    },
                    password: {
                        title: 'New password',
                        type: 'password',
                        placeholder: 'Type your new password',
                        validation: ['required', 'password']
                    },
                    repeat_password: {
                        title: 'Repeat password',
                        type: 'password',
                        placeholder: 'Type your new password again',
                        validation: ['required', 'repeatPassword']
                    },
                }
            },
            getTgText() {
                let message = "To receive telegram notifications, fill in the 'Telegram' " +
                    "field and connect to the telegram bot using the link <a href=\"https://t.me/TprojBot\">https://t.me/TprojBot</a>"
                return this.userActions ? message : ""
            },
            notifyFields() {
                return {
                    email: {
                        type: 'checkbox-group',
                        title: 'Email notification',
                        options: [
                            {
                                id: 'task',
                                title: 'New task'
                            },
                            {
                                id: 'mention',
                                title: 'New mention'
                            },
                            {
                                id: 'comment',
                                title: 'New comment'
                            }
                        ]
                    },
                    tg: {
                        type: 'checkbox-group',
                        title: 'Telegram notification',
                        disabled: !!this.userActions,
                        info: this.getTgText,
                        options: [
                            {
                                id: 'task',
                                title: 'New task'
                            },
                            {
                                id: 'mention',
                                title: 'New mention'
                            },
                            {
                                id: 'comment',
                                title: 'New comment'
                            }
                        ]
                    }
                }
            },
            userNotifications() {
                return this.$store.getters['notifications/getNotificationSettings']
            },
            buttons() {
                return {
                    save: {
                        title: 'Save',
                        type: 'submit',
                        variant: 'success',
                        class: 'mr-3'
                    },
                    custom: {
                        title: 'Change Password',
                    }
                }
            },
            countries() {
                let cnts = JSON.parse(JSON.stringify(COUNTRIES))
                cnts.unshift({value: null, title: 'Country'})
                return cnts
            },
            timeZones() {
                let times = TIME_ZONES
                times.unshift({value: null, title: 'Time zone'})
                return times
            },
            fields() {
                return {
                    email: {
                        type: 'text',
                        title: 'E-mail',
                        disabled: true
                    },
                    telegram: {
                        type: 'text',
                        title: 'Telegram',
                        placeholder: 'Phone number or username in Telegram',
                    },
                    phone: {
                        type: 'text',
                        title: 'Phone number',
                        placeholder: '+ 375 33 123 45 66',
                    },
                    location: {
                        type: 'select',
                        title: 'Location',
                        options: this.countries,
                    },
                    dob: {
                        type: 'date',
                        title: 'Date ob birth',
                    },
                    time_zone: {
                        type: 'select',
                        title: 'Time zone',
                        options: this.timeZones,
                    }
                }
            },
            currentUser() {
                let u = this.$store.getters['auth/currentUser'];
                if (!Object.keys(u).includes('location')) {
                    u.location = null
                }
                if (!Object.keys(u).includes('time_zone')) {
                    u.time_zone = ''
                }
                if (!Object.keys(u).includes('dob')) {
                    u.time_zone = ''
                }
                return u
            }
        },
        methods: {
            openPassModal() {
                this.$bvModal.show('change-pass-modal')
            },
            async changePassword(bvModalEvent) {
                this.$refs.changePassword.$v.$touch()
                if (this.$refs.changePassword.$v.$invalid) {
                    bvModalEvent.preventDefault()
                    return false
                }
                let vals = this.$refs.changePassword.formValues
                bvModalEvent.preventDefault()
                try {
                    await auth.changePassword(vals)
                    this.$bvModal.hide('change-pass-modal')
                } catch (e) {
                    this.passError = e.data.message
                    return false
                }
            },
            updateSettings(vals) {
                this.$store.dispatch('notifications/updateNotificationSettings', vals)
            },
            async save(vals) {
                let opt = {}
                for (let key in vals) {
                    if (Object.keys(this.fields).includes(key)) {
                        if (vals[key] === 0 || vals[key] === "" || vals[key] === undefined) {
                            opt[key] = null
                        } else {
                            opt[key] = vals[key]
                        }
                    }
                }
                opt.id = vals.id
                try {
                    let u = await auth.updateUser(opt)
                    this.$store.commit('auth/UPDATE_USER_FIELDS', u)
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }
</script>

<style lang="scss">
    #change-pass-modal {
        .error {
            color: red;
        }
    }
    .user-profile {
        padding: 25px 50px;
        h2 {
            position: relative;
            overflow: hidden;
            margin-top: 20px;
            span {
                padding-right: 10px;
                color: #212529;
            }
            &:after {
                content: "";
                display: inline-block;
                height: 0.5em;
                vertical-align: bottom;
                width: 100%;
                margin-right: -100%;
                margin-left: 10px;
                border-top: 1px solid #E8E8E8;
            }
        }

        .notification-checkboxes {
            .ap-form {
                .control-checkbox-group {
                    margin-bottom: 20px;
                    legend {
                        font-weight: bold;
                    }
                    &:first-child {
                        margin-top: 20px;
                    }
                    .checkbox-group {
                        display: flex;
                        justify-content: flex-start;
                        flex-direction: row;
                        flex-wrap: wrap;
                        .info-message {
                            width: 100%;
                            margin-bottom: 5px;
                        }
                        .custom-checkbox {
                            margin-right: 20px;
                        }
                    }
                }
            }
        }

        .user-form {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            flex-direction: row;

            @media screen and (max-width: 850px)  {
                flex-wrap: wrap;
            }

            .user-info-wrap {
                text-align: center;
                margin-top: 10px;
                p {
                    font-weight: bold;
                }
            }

            .avatar-item {
                width: 380px;
                @media screen and (max-width: 850px)  {
                    width: 100%;
                }
            }
            .edit-form {
                width: calc(100% - 380px);
                @media screen and (max-width: 850px)  {
                    width: 100%;
                }
                .ap-form {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .control-date {
                        .mx-datepicker {
                            width: 100%;
                            .mx-input {
                                height: 41px;
                            }
                        }
                    }
                    div[class*="control-"] {
                        width: 48%;
                        @media screen and (max-width: 1024px)  {
                            width: 100%!important;
                            &:nth-child(odd) {
                                margin-right: 0!important;
                            }
                        }
                        &:nth-child(odd) {
                            margin-right: 2%;
                        }
                        &:nth-child(even) {
                            width: 50%;
                        }
                    }
                }
            }
        }
    }
</style>